import { render } from "./iconPrint.vue?vue&type=template&id=38552635"
import script from "./iconPrint.vue?vue&type=script&lang=js"
export * from "./iconPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__